import { createSlice, PayloadAction } from '@reduxjs/toolkit';
const SLICE_ID = 'editor__actions';

export type PlayAction = 'all' | 'audio';
export type AddClipAction = 'startTime' | 'endTime' | 'split';
export type AddFileAction = 'local' | 'google';

export interface EditorActions {
  addClipAction: AddClipAction;
  playAction: PlayAction;
  addFileAction: AddFileAction;
}

const initialState: EditorActions = {
  addClipAction: 'startTime',
  playAction: 'all',
  addFileAction: 'local',
};

// S L I C E

export const backupSlice = createSlice({
  name: SLICE_ID,
  initialState,
  reducers: {
    setAddClipAction: (state, action: PayloadAction<AddClipAction>) => {
      state.addClipAction = action.payload;
    },
    setPlayAction: (state, action: PayloadAction<PlayAction>) => {
      state.playAction = action.payload;
    },
    setAddFileAction: (state, action: PayloadAction<AddFileAction>) => {
      state.addFileAction = action.payload;
    },
  },
});

export const { setAddClipAction, setPlayAction, setAddFileAction } = backupSlice.actions;
export default backupSlice.reducer;
